// extracted by mini-css-extract-plugin
export default {"container":"Faq_container__l+Jua","wrapper":"Faq_wrapper__ZNDZ3"};